import React from "react";
import { LineChart, Line, ReferenceLine, ResponsiveContainer, Tooltip, YAxis } from "recharts";

export function Sparkline({ data, line, pick, height = 50 }) {
  const series = data.map((g, i) => ({ idx: i + 1, value: g.value, opponent: g.opponent, date: g.date }));
  const values = series.map((s) => s.value);
  const min = Math.min(...values, line) * 0.85;
  const max = Math.max(...values, line) * 1.15;
  const stroke = pick === "OVER" ? "#FF4500" : "#00E5FF";
  return (
    <div style={{ width: "100%", height, minHeight: height, minWidth: 80 }} data-testid="prop-sparkline">
      <ResponsiveContainer width="100%" height={height} minWidth={80} minHeight={height}>
        <LineChart data={series} margin={{ top: 4, right: 4, left: 4, bottom: 0 }}>
          <YAxis hide domain={[min, max]} />
          <ReferenceLine y={line} stroke="#FFFFFF" strokeOpacity={0.45} strokeDasharray="3 3" />
          <Line
            type="monotone"
            dataKey="value"
            stroke={stroke}
            strokeWidth={2}
            dot={{ r: 2, fill: stroke }}
            activeDot={{ r: 4 }}
            isAnimationActive={false}
          />
          <Tooltip
            cursor={{ stroke: "#3f3f46" }}
            contentStyle={{ background: "#0A0A0A", border: "1px solid #27272A", borderRadius: 0, fontFamily: "Manrope", fontSize: 12 }}
            labelStyle={{ color: "#A1A1AA" }}
            itemStyle={{ color: "#fff" }}
            formatter={(v) => [v, "Value"]}
            labelFormatter={(l) => `Game ${l}`}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export function FullChart({ data, line, pick, height = 280 }) {
  const series = data.map((g, i) => ({ idx: i + 1, value: g.value, opponent: g.opponent, date: g.date }));
  const values = series.map((s) => s.value);
  const min = Math.min(...values, line) * 0.85;
  const max = Math.max(...values, line) * 1.15;
  const stroke = pick === "OVER" ? "#FF4500" : "#00E5FF";
  return (
    <div style={{ width: "100%", height }} data-testid="player-full-chart">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={series} margin={{ top: 12, right: 16, left: 16, bottom: 8 }}>
          <YAxis
            domain={[min, max]}
            stroke="#52525b"
            tick={{ fill: "#A1A1AA", fontSize: 11, fontFamily: "Manrope" }}
            axisLine={false}
            tickLine={false}
          />
          <ReferenceLine
            y={line}
            stroke="#FFFFFF"
            strokeOpacity={0.6}
            strokeDasharray="4 4"
            label={{ value: `Line ${line}`, fill: "#fff", fontSize: 11, position: "right", fontFamily: "Manrope" }}
          />
          <Line
            type="monotone"
            dataKey="value"
            stroke={stroke}
            strokeWidth={2.5}
            dot={{ r: 4, fill: stroke, stroke: "#0A0A0A", strokeWidth: 2 }}
            activeDot={{ r: 6 }}
            isAnimationActive={true}
          />
          <Tooltip
            cursor={{ stroke: "#3f3f46" }}
            contentStyle={{ background: "#0A0A0A", border: "1px solid #27272A", borderRadius: 0, fontFamily: "Manrope", fontSize: 12 }}
            labelStyle={{ color: "#A1A1AA" }}
            itemStyle={{ color: "#fff" }}
            formatter={(v) => [v, "Stat"]}
            labelFormatter={(l, payload) => payload?.[0]?.payload ? `${payload[0].payload.date} ${payload[0].payload.opponent}` : `Game ${l}`}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
